import 'picturefill';
import 'lazysizes';
import 'core-js/es/object/assign';
import 'core-js/es/number/is-nan';
import MoveTo from 'moveto';
import { areaSlide } from './modules/area-slide';
import { charaSlide } from './modules/chara-slide';
import { charaFrame } from './modules/chara-frame';
import { bgBlur } from './modules/bg-blur';
import { scrollToTop } from './modules/scrollto-top';
import { video } from './modules/video';
import './modules/chara-modal';
import './modules/ga';
import './modules/set-css-vh';
import { drawerMenu } from './modules/drawer-menu';
import { sendga } from './modules/ga';
import { toggleBox } from './modules/toggle-box';
/**
 * メディアクエリオブジェクト
 */
const mqlSmallView = window.matchMedia('(max-width: 770px)');
/**
 * 開発環境以外での右クリックの禁止
 */
if (process.env.NODE_ENV !== 'development') {
    document.oncontextmenu = () => false;
    window.addEventListener('DOMContentLoaded', () => {
        const imgEls = document.querySelectorAll('img');
        // 画像ドラッグの無効化
        imgEls.forEach(el => {
            el.draggable = false;
        });
    });
}
/**
 * エリアカルーセルの初期化
 */
window.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.area-carousel');
    if (el === null) {
        return;
    }
    // スライドの初期化
    areaSlide(el.querySelector('.swiper-container'));
});
/**
 * キャラカルーセルの初期化
 */
window.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.character-carousel');
    if (el === null) {
        return;
    }
    // スライドの初期化
    charaSlide(el.querySelector('.swiper-container'));
});
/**
 * キャラフレームの調整
 */
window.addEventListener('load', () => {
    charaFrame(document.querySelector('#js-box-character'));
});
/**
 * 背景ブラー機能の初期化
 */
window.addEventListener('load', () => {
    bgBlur(document.querySelector('#js-bg-blur'));
});
/**
 * トップへ戻るの初期化
 */
window.addEventListener('load', () => {
    scrollToTop(document.querySelector('#js-scrollto-top'));
});
/**
 * ページ内スクロールの初期化
 */
window.addEventListener('DOMContentLoaded', () => {
    const moveTo = new MoveTo();
    Array.from(document.querySelectorAll('a[href^="#"]:not(.without-smooth)')).forEach((el) => {
        if (el !== null) {
            moveTo.registerTrigger(el);
        }
    });
});
/**
 * アップデート情報エリアの初期化
 */
window.addEventListener('DOMContentLoaded', () => {
    // スマホ用ボタン
    const btn1 = document.querySelector('#js-article-toggle-1');
    const btn2 = document.querySelector('#js-article-toggle-2');
    const btn3 = document.querySelector('#js-article-toggle-3');
    const btn4 = document.querySelector('#js-article-toggle-4');
    // PC用タブ
    const tab1 = document.querySelector('#js-article-tab-1');
    const tab2 = document.querySelector('#js-article-tab-2');
    const tab3 = document.querySelector('#js-article-tab-3');
    const tab4 = document.querySelector('#js-article-tab-4');
    // 記事ボックス
    const box1 = document.querySelector('#js-article-1');
    const box2 = document.querySelector('#js-article-2');
    const box3 = document.querySelector('#js-article-3');
    const box4 = document.querySelector('#js-article-4');
    if (!btn1 || !btn2 || !btn3 || !btn4 ||
        !tab1 || !tab2 || !tab3 || !tab4 ||
        !box1 || !box2 || !box3 || !box4) {
        return;
    }
    const toggleBox1 = toggleBox(box1, {
        isShow: box1.classList.contains('active'),
        on: {
            beforeClose: () => {
                tab1.classList.remove('active');
                btn1.classList.remove('active');
            },
            beforeOpen: () => {
                tab1.classList.add('active');
                btn1.classList.add('active');
            }
        }
    });
    const toggleBox2 = toggleBox(box2, {
        isShow: box2.classList.contains('active'),
        on: {
            beforeClose: () => {
                tab2.classList.remove('active');
                btn2.classList.remove('active');
            },
            beforeOpen: () => {
                tab2.classList.add('active');
                btn2.classList.add('active');
            }
        }
    });
    const toggleBox3 = toggleBox(box3, {
        isShow: box3.classList.contains('active'),
        on: {
            beforeClose: () => {
                tab3.classList.remove('active');
                btn3.classList.remove('active');
            },
            beforeOpen: () => {
                tab3.classList.add('active');
                btn3.classList.add('active');
            }
        }
    });
    const toggleBox4 = toggleBox(box4, {
        isShow: box4.classList.contains('active'),
        on: {
            beforeClose: () => {
                tab4.classList.remove('active');
                btn4.classList.remove('active');
            },
            beforeOpen: () => {
                tab4.classList.add('active');
                btn4.classList.add('active');
            }
        }
    });
    if (!toggleBox1 || !toggleBox2 || !toggleBox3 || !toggleBox4) {
        return;
    }
    btn1.addEventListener('click', () => {
        toggleBox1.toggle();
    });
    btn2.addEventListener('click', () => {
        toggleBox2.toggle();
    });
    btn3.addEventListener('click', () => {
        toggleBox3.toggle();
    });
    btn4.addEventListener('click', () => {
        toggleBox4.toggle();
    });
    // タブ切り替え
    tab1.addEventListener('click', () => {
        toggleBox1.toggle();
        toggleBox2.close();
        toggleBox3.close();
        toggleBox4.close();
    });
    tab2.addEventListener('click', () => {
        toggleBox1.close();
        toggleBox2.toggle();
        toggleBox3.close();
        toggleBox4.close();
    });
    tab3.addEventListener('click', () => {
        toggleBox1.close();
        toggleBox2.close();
        toggleBox3.toggle();
        toggleBox4.close();
    });
    tab4.addEventListener('click', () => {
        toggleBox1.close();
        toggleBox2.close();
        toggleBox3.close();
        toggleBox4.toggle();
    });
    /**
     * ドロワメニューの初期化
     */
    // トグルボタン
    const toggleBtnEl = document.getElementById('js-drawer-toggle');
    if (!toggleBtnEl) {
        return;
    }
    // メニュー機能初期化
    const menu = drawerMenu('.drawer-menu', {
        on: {
            clickLink: (target) => {
                menu?.toggle(false);
                if (target !== null) {
                    let targetEl = target;
                    const url = new URL(targetEl.href);
                    switch (url.hash) {
                        case '#js-article-toggle-1':
                            toggleBox1.open(1);
                            break;
                        case '#js-article-toggle-2':
                            toggleBox2.open(1);
                            break;
                        case '#js-article-toggle-3':
                            toggleBox3.open(1);
                            break;
                        case '#js-article-toggle-4':
                            toggleBox4.open(1);
                            break;
                    }
                }
                sendga('スマホメニューリンク押下');
            },
            beforeOpen: () => {
                toggleBtnEl.classList.add('is-active');
                sendga('スマホメニューオープン');
            },
            beforeClose: () => {
                toggleBtnEl.classList.remove('is-active');
                sendga('スマホメニュークローズ');
            }
        }
    });
    if (!menu) {
        return;
    }
    toggleBtnEl.addEventListener('click', () => {
        menu.toggle();
    });
    /**
     * ビューサイズ切り替え
     * 切り替えがあった場合は初期表示に戻す
     */
    mqlSmallView.addListener(evt => {
        toggleBox1.close(1);
        toggleBox2.close(1);
        toggleBox3.close(1);
        toggleBox4.open(1);
    });
});
/**
 * 動画の初期化
 */
video('#js-video');
